import React from "react";
import { Button } from "../Button/Button";
import heroImageDesktop from "../../Recursos/hero_image_desktop.webp";
import { CourseCircleIcon } from "../Icons/Miscellaneous/CourseCircleIcon";
import { CourseCircleDesktopIcon } from "../Icons/Miscellaneous/CourseCircleDesktopIcon";
import { CourseBundleCircleIcon } from "../Icons/Miscellaneous/CourseBundleCircleIcon";
import { CourseBundleCircleDesktopIcon } from "../Icons/Miscellaneous/CourseBundleCircleDesktopIcon";
import { useDesktop } from "Hooks/useDesktop";
import { useDispatch } from "react-redux";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { DRAWER_TYPES } from "Constantes/drawers";
import { ChevronDownIcon } from "Components/Icons/Arrows/ChevronDownIcon";
import { IconButton } from "@mui/material";
import { paramService } from "Services/param_service";
import { useQuery } from "Hooks/useQuery";
import "./Hero.scss";

export const Hero = () => {
  const dispatch = useDispatch();
  const handleCreateAccount = () => {
    dispatch(setActiveDrawer(DRAWER_TYPES.REGISTER));
  };

  const handleScrollToBottom = () => {
    const element = document.getElementById("tabs-categories");
    if (element) {
      const elementPosition = element.offsetTop - 18;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  const { data: images } = useQuery(paramService.param, {
    grupo: "imagenes",
    files: true,
  });

  const banner =
    images?.data.find((item) => item.codigoParametro === "banner")?.url || "#";

  const isDesktop = useDesktop();

  return (
    <div className="hero-container">
      <section className="hero">
        <div className="hero__banner">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">Aprende con Nuestros Cursos</h1>
              <h2 className="hero__subtitle">¡Gratis para todos!</h2>
            </div>

            <div className="hero__register-btn hero__register-btn--tablet-up">
              <Button onClick={handleCreateAccount} size="medium">
                CREAR UNA CUENTA
              </Button>
            </div>
          </div>

          <div className="hero__image">
            <img
              src={banner}
              alt="Estudiantes aprendiendo - Hombre con sombrero y mujer con libros"
              className="hero__img"
              onError={(e) => {
                e.target.src = heroImageDesktop;
              }}
            />
            <IconButton
              onClick={handleScrollToBottom}
              className="hero__scroll-to-bottom"
            >
              <ChevronDownIcon className="text-blanco" width={36} height={36} />
            </IconButton>
          </div>
        </div>

        <div className="hero__register-btn hero__register-btn--mobile">
          <Button onClick={handleCreateAccount}>CREAR UNA CUENTA</Button>
        </div>
      </section>

      <div className="hero__learn-section">
        <h3 className="hero__learn-title">
          ¡Te apoyamos en tu Ruta de Desarrollo!
        </h3>

        <div className="hero__cards">
          <div className="hero__card">
            <div className="hero__card-icon">
              {isDesktop ? <CourseCircleDesktopIcon /> : <CourseCircleIcon />}
            </div>
            <div className="hero__card-content">
              <h4 className="hero__card-title">Cursos</h4>
              <p className="hero__card-description">
                Son cursos cortos que puedes completar en poco tiempo.
              </p>
            </div>
          </div>

          <div className="hero__card">
            <div className="hero__card-icon">
              {isDesktop ? (
                <CourseBundleCircleDesktopIcon />
              ) : (
                <CourseBundleCircleIcon />
              )}
            </div>
            <div className="hero__card-content">
              <h4 className="hero__card-title">Paquete de Cursos</h4>
              <p className="hero__card-description">
                Son grupos de cursos para aprender más sobre un tema.
              </p>
            </div>
          </div>
        </div>

        <div className="hero__invitation">
          <h3 className="hero__invitation-title">
            ¡Elije el curso que te ayude más!
          </h3>
          <div className="hero__invitation-text">
            <p>Aquí puedes aprender lo que necesitas. Selecciona un tema</p>
          </div>
        </div>
      </div>
    </div>
  );
};
